<template>
    <div>
        <div class="panel-tag mt-3" v-if="totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div class="dataTables_wrapper dt-bootstrap4" v-show="totalEntries != 0">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table id="commissionItemTable" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" :style="setTableHeaderStyle(tblHeader.key)" >{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                            <tr><td colspan="10" class="text-right pr-2">
                                <a class="btn btn-xs btn-outline-primary text-primary" @click="expandAll">{{isExpandAll == 'Expand' ? $t('button_link.expand_all') : $t('button_link.collapse_all')}}</a>
                            </td></tr>
                        <commissionItemsTable ref="serviceItem" :items="serviceItems" :type="'service'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" @showEditCommission="showEditCommission" @sortItems="sortItems"></commissionItemsTable>
                        <commissionItemsTable ref="productItem" :items="productItems" :type="'product'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" @showEditCommission="showEditCommission" @sortItems="sortItems"></commissionItemsTable>
                        <commissionItemsTable ref="packageItem" :items="packageItems" :type="'package'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" @showEditCommission="showEditCommission" @sortItems="sortItems"></commissionItemsTable>
                        <!-- <commissionItemsTable ref="discountItem" :items="discountItems" :type="'discount'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" @showEditCommission="showEditCommission"></commissionItemsTable> -->
                        <commissionItemsTable ref="outstandingsItem" :items="outstandingsItem" :type="'outstandings'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" @showEditCommission="showEditCommission" @sortItems="sortItems"></commissionItemsTable>
                    </table>
                </div>
            </div>
        </div>
        <div v-show="totalEntries != 0" class="dataTables_info" role="status" aria-live="polite">{{$t('table.pagination_short',{'totalEntries': totalEntries})}}</div>
        <div v-if="modalShow" class="modal fade show">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t('subMenu.salon_report_order')}}
                            <small class="m-0 text-muted"><span class="text-capitalize">{{$t('salon_report.item_types.' + editData.type)}}: </span>{{editData.title}}</small>
                        </h5>
                        <button type="button" class="close" @click="modalShow = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.receipt_number')}}: </div>
                            <div class="col-10 fw-300">{{editData.receiptID}}</div>
                        </div>
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.order_number')}}: </div>
                            <div class="col-10 fw-300">{{editData.orderID}}</div>
                        </div>
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.amount')}}: </div>
                            <div class="col-10 fw-500">{{parseFloat(editData.price).toFixed(2)}}</div>
                        </div>
                        <h6 class="pt-2 text-secondary fw-500"><i class="fas fa-store mr-2"></i>{{editData.outlet}}</h6>
                        <div class="dataTables_wrapper dt-bootstrap4">
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                                        <thead class="thead-themed">
                                            <tr>
                                                <th v-for="tblHeader in editFields" :key="tblHeader.key" :style="setTableHeaderStyle(tblHeader.key)">{{tblHeader.label}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(staff, index) in editData.staffs" :key="index">
                                            <commissionItemEdit ref="commissionItemEdit" :price="editData.price" :index="index" :staffsList="staffsList" :staff="staff"></commissionItemEdit>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="text-left border-top pt-3 mt-3 mb-3">
                                <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitEditCommission">{{$t('button_link.save')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

import CommissionItemsTable from './Commission_ItemsTable'
import CommissionItemEdit from './Commission_ItemEdit'
export default {
    name: 'commissionItem',
    components:{
        CommissionItemsTable, CommissionItemEdit
    },
    data(){
        return{
            totalEntries: 0,
            serviceItems: [],
            productItems: [],
            packageItems: [],
            discountItems: [],
            outstandingsItem: [],
            isExpandAll: "Expand", isExpandCount: 0,
            modalShow: false, editData: {}, staffsList: [],
            filterObj: {}
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#"},
                { key: "title", label: ""},
                { key: "position", label: this.$i18n.t('table.header.position')},
                { key: "staff", label: this.$i18n.t('table.header.staff')},
                { key: "amount", label: this.$i18n.t('table.header.amount')},
                { key: "effort", label: this.$i18n.t('table.header.effort')},
                { key: "percentage", label: this.$i18n.t('table.header.effort_percentage')},
                { key: "fee", label: this.$i18n.t('table.header.fee')},
                { key: "action", label: ""}
            ]
        },
        editFields(){
            return[
                { key: "index", label: "#"},
                { key: "editStaff", label: this.$i18n.t('table.header.staff')},
                { key: "editEffort", label: this.$i18n.t('table.header.effort')},
                { key: "editPercentage", label:  this.$i18n.t('table.header.effort_percentage')},
                { key: "editFee", label: this.$i18n.t('table.header.fee')}
            ]
        }
    },
    methods:{
        sortItems(opt, type){
            switch(type){
                case"service": 
                    this.serviceItems = this.sort(opt, this.serviceItems)
                    break;
                case"product": 
                    this.productItems = this.sort(opt, this.productItems)
                    break;
                case"package": 
                    this.packageItems = this.sort(opt, this.packageItems)
                    break;
                case"outstandings": 
                    this.outstandingsItem = this.sort(opt, this.outstandingsItem)
                    break;
            }
        },
        sort(opt, result){
            if(opt == 'date_desc'){
                result = _.orderBy(result, ['createDate'], ['desc'])
            }else if(opt == 'date_asc'){
                result = _.orderBy(result, ['createDate'], ['asc'])
            }else{
                result = _.orderBy(result, ['redeem'], ['asc'])
            }
            return result
        },
        setTableHeaderStyle(id){
            var style = {}
            switch(id){
                case "title":
                    style = {'width': '35%'};
                    break;
                // case "outlet":
                //     style = {'width': '20%'};
                //     break;
                case "editStaff":
                    style = {'width': '30%'};
                    break;
            }
            return style
        },
        updateTable(item, filterObj){
            this.filterObj = filterObj
            this.totalEntries = 0;
            var group = _.groupBy(item, 'item.type');
            this.populateTable(group);
            this.isExpandAll == "Expand"
        },
        populateTable(item){
            this.serviceItems = "service" in item ? item["service"] : [];
            this.productItems = "product" in item ? item["product"] : [];
            this.packageItems = "package" in item ? item["package"] : [];
            // this.discountItems = "discount" in item ? item["discount"] : [];
            this.outstandingsItem = "outstandings" in item ? item["outstandings"] : [];
        },
        setTotalEntries(len){
            this.totalEntries += len
        },
        expandAll(){
            var isExpand = false;
            if(this.isExpandAll == "Expand"){
                isExpand = true;
                this.isExpandAll = "Collapse"
            }else{
                isExpand = false;
                this.isExpandAll = "Expand"
            }
            this.$refs.serviceItem.showAllDetails('service', isExpand);
            this.$refs.productItem.showAllDetails('product', isExpand);
            this.$refs.packageItem.showAllDetails('package', isExpand);
            // this.$refs.discountItem.showAllDetails('discount', isExpand);
            this.$refs.outstandingsItem.showAllDetails('outstandings', isExpand);
            
        },
        setExpandAll(status){
            if(status == "Collapse"){
                this.isExpandCount ++;
            }else{
                if(this.isExpandCount != 0)
                this.isExpandCount --;
            }
            var outletExpand = document.getElementById('commissionItemTable').querySelectorAll(".itemExpand");
            if(outletExpand.length == this.isExpandCount){
                this.isExpandAll = "Collapse"
                this.isExpandCount = 0
            }else{
                this.isExpandAll = "Expand"
            }
        },
        closeModal(isError){
            if(!isError){
                this.modalShow = false;
                this.$emit('getCommissionItems', this.filterObj);
            }
            this.$parent.$parent.isModalShow = false
        },
        showEditCommission(data){
            this.modalShow = true
            this.editData = data
            this.getStaffItems(data.outletID)
        },
        getStaffItems(outletID){
            var staff = [{ staffID: 'no',
                name: 'No Staff',
                effort: 0,
                pctg: 0,
                pctg2: 0,
                fee: 0
            }];
            let $vm = this
            let url = this.$api.OUTLET + "/" + outletID + this.$api.STAFF
            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                $vm.staffsList = response.data.staff;
                $vm.staffsList.push(...staff);
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        submitEditCommission(){
            var arrData = [];
            let $vm = this
            if(this.modalShow){
                for(var i=0; i<this.$refs.commissionItemEdit.length; i++){
                    var staff = this.$refs.commissionItemEdit[i].submitStaffItems();
                    if(staff.staffID != "no"){
                        arrData.push(staff)
                    }
                }
                const url =  this.$api.REPORT_COMPLETED + "/" + this.editData.completedID + this.$api.UPDATE;
                this.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: this.$axios.defaults.baseURL, 
                    headers: {token: this.$util.getSessionToken()},
                    data: {staffs: arrData}
                })
                .then((response) => {
                    if(response.status == 200){
                        var retData = response.data.result[0];
                        var message = retData.item.title + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                        $vm.$parent.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if(errData.error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();   
                    }else{
                        var message = errData.message;
                        $vm.$parent.$parent.setModal($vm, true, true, message);
                    }
                })
            }
        }
    },
}
</script>
<style scoped>
.scrollSpy-container{
    position: fixed;
    top: 40%;
    margin-left: -6.5em;
}
.show{
    display: block;
}
.modal-body-lg{
    min-height: 60vh;
    max-height: 80vh;
    overflow-y: auto;
}
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
</style>
